import { createRouter, createWebHashHistory } from "vue-router";

import DashboardLayout from "@/views/Layout/DashboardLayout";
import AuthLayout from "@/views/Pages/AuthLayout";

// Dashboard pages
import Dashboard from "../views/Dashboard/Dashboard.vue";
import Alternative from "../views/Dashboard/AlternativeDashboard.vue";
import Widgets from "../views/Widgets.vue";
import Charts from "../views/Charts.vue";
import Calendar from "../views/Calendar/Calendar.vue";
import TechDashboard from "../views/Dashboard/TechDashboard.vue";
import SalesDashboard from "../views/Dashboard/SalesDashboard.vue";
import DatabaseDashboard from "../views/Dashboard/DatabaseDashboard.vue";
import ScheduledDashboard from "../views/Dashboard/ScheduledTaskDetail.vue";
import SystemDashboard from "../views/Dashboard/SystemDashboard.vue";
import StatusDashboard from "../views/Dashboard/StatusDashboard.vue";
import AnalyticsDashboard from "../views/Dashboard/AnalyticsDashboard.vue";
import StrategyAnalysisDashboard from "../views/Dashboard/StrategyAnalysisDashboard.vue";
import PositionDetails from "../views/Dashboard/PositionDetails.vue";

// Pages
import Pricing from "../views/Pages/Pricing.vue";
import Login from "../views/Pages/Login.vue";
import Register from "../views/Pages/Register.vue";
import Lock from "../views/Pages/Lock.vue";
import Profile from "../views/Pages/UserProfile.vue";
import Timeline from "../views/Pages/TimeLinePage.vue";
import StrategyMonthlyData from "../views/Dashboard/StrategyMonthlyData.vue";
import PausedStatus from "../views/Dashboard/PausedStatus.vue";

// Components pages
import Buttons from "../views/Components/Buttons.vue";
import Cards from "../views/Components/Cards.vue";
import Grid from "../views/Components/GridSystem.vue";
import Notifications from "../views/Components/Notifications.vue";
import Icons from "../views/Components/Icons.vue";
import Typography from "../views/Components/Typography.vue";

// Tables pages
import RegularTables from "../views/Tables/RegularTables.vue";
import SortableTables from "../views/Tables/SortableTables.vue";
import PaginatedTables from "../views/Tables/PaginatedTables.vue";

// Maps pages
import GoogleMaps from "../views/Maps/GoogleMaps.vue";
import VectorMaps from "../views/Maps/VectorMaps.vue";

// Forms pages
import FormElements from "../views/Forms/FormElements.vue";
import FormComponents from "../views/Forms/FormComponents.vue";
import FormValidation from "../views/Forms/FormValidation.vue";

// System pages
import Users from "../views/System/Users.vue";
import Brokers from "../views/System/Brokers.vue";
import Orders from "../views/Reports/Orders.vue";
import Settings from "../views/Settings/SettingsPage.vue";
import Holidays from "../views/System/Holidays.vue";
import Instruments from "../views/System/InstrumentDetails.vue";
import Portfolios from "../views/System/Portfolios.vue";
import Variations from "../views/System/Variations.vue";
import Feeder from "../views/System/Feeder.vue";
import OrderRetry from "../views/System/OrderRetry.vue";
import OrderDetail from "../views/System/OrderDetail.vue";
import Onboarding from "../views/System/Onboarding.vue";
import UploadUsers from "../views/System/UploadUsers.vue";
import store from "../store/index.js";
import HomePage from "../views/HomePage/HomePage.vue";
import { getDataFromStorage } from '../views/System/emitter';
import CandleStickChart from "../views/System/CandleStickChart.vue";

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      components: { default: Buttons },
      meta: {
        hideFooter: true,
        hideSidebar: true,
      },
    },
    {
      path: "cards",
      name: "Cards",
      components: { default: Cards },
    },
    {
      path: "grid-system",
      name: "Grid",
      components: { default: Grid },
    },
    {
      path: "notifications",
      name: "Notifications",
      components: { default: Notifications },
    },
    {
      path: "icons",
      name: "Icons",
      components: { default: Icons },
    },
    {
      path: "typography",
      name: "Typography",
      components: { default: Typography },
    },
  ],
};

let tablesMenu = {
  path: "/tables",
  component: DashboardLayout,
  redirect: "/tables/regular",
  name: "Tables menu",
  children: [
    {
      path: "regular",
      name: "Tables",
      components: { default: RegularTables },
    },
    {
      path: "sortable",
      name: "Sortable",
      components: { default: SortableTables },
    },
    {
      path: "paginated",
      name: "Paginated",
      components: { default: PaginatedTables },
    },
  ],
};
let systemMenu = {
  path: "/system",
  component: DashboardLayout,
  redirect: "/system/users",
  name: "System menu",
  children: [
    {
      path: "users",
      name: "Users",
      components: { default: Users },
      beforeEnter: isAuthenticated,
    },
    {
      path: "brokers",
      name: "Brokers",
      components: { default: Brokers },
      beforeEnter: isAuthenticated,
    },
    {
      path: "holidays",
      name: "Holidays",
      components: { default: Holidays },
      beforeEnter: isAuthenticated,
    },
    {
      path: "instruments",
      name: "Instruments",
      components: { default: Instruments },
      beforeEnter: isAuthenticated,
    },
    {
      path: "portfolios",
      name: "Portfolios",
      components: { default: Portfolios },
      beforeEnter: isAuthenticated,
    },
    {
      path: "variations",
      name: "Variations",
      components: { default: Variations },
      beforeEnter: isAuthenticated,
    },
    {
      path: "feeder",
      name: "Feeder",
      components: { default: Feeder },
      beforeEnter: isAuthenticated,
    },
    {
      path: "orderRetry",
      name: "OrderRetry",
      components: { default: OrderRetry },
      beforeEnter: isAuthenticated,
    },
    {
      path: "orderDetail",
      name: "OrderDetail",
      components: { default: OrderDetail },
      beforeEnter: isAuthenticated,
    },
    {
      path: "onboarding",
      name: "Onboarding",
      components: { default: Onboarding },
      beforeEnter: isAuthenticated,
    },
    {
      path: "uploadUsers",
      name: "UploadUsers",
      components: { default: UploadUsers },
      beforeEnter: isAuthenticated,
    },
     {
      path: "candlestick",
      name: "CandleStick Chart",
      components: { default: CandleStickChart },
      beforeEnter: isAuthenticated,
    },
  ],
};
let reportMenu = {
  path: "/report",
  component: DashboardLayout,
  redirect: "/report/orders",
  name: "Order Menu",
  children: [
    {
      path: "orders",
      name: "Orders",
      components: { default: Orders },
      beforeEnter: isAuthenticated,
    }
  ],
};
let buttonsMenu = {
  path: "/buttonsPage",
  component: DashboardLayout,
  redirect: "/buttonsPage/setting",
  name: "Buttons Menu",
  children: [
    {
      path: "setting",
      name: "Settings",
      components: { default: Settings },
    }
  ],
};


let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  redirect: "/maps/google",
  name: "Maps",
  children: [
    {
      path: "google",
      name: "Google Maps",
      components: { default: GoogleMaps },
    },
    {
      path: "vector",
      name: "Vector Map",
      components: { default: VectorMaps },
    },
  ],
};

let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/elements",
  name: "Forms",
  children: [
    {
      path: "elements",
      name: "Forms elements",
      components: { default: FormElements },
    },
    {
      path: "components",
      name: "Forms Components",
      components: { default: FormComponents },
    },
    {
      path: "validation",
      name: "Forms Validation",
      components: { default: FormValidation },
    },
  ],
};

const routes = [
  {
    path: "/",
    redirect: () => {
      const userId = getDataFromStorage().userId;
      return userId ? "/system/users" : "/homePage";
    },
    component: DashboardLayout,
    name: "Dashboards",
    children: [
      {
        path: "/dashboard",
        name: "Dashboard",
        components: { default: Dashboard },
      },
      {
        path: "/alternative",
        name: "Alternative",
        components: { default: Alternative },
        meta: {
          navbarType: "light",
        },
      },
      {
        path: "/techDashboard",
        name: "TechDashboard",
        components: { default: TechDashboard },
        beforeEnter: isAuthenticated,
        meta: {
          navbarType: "light",
        },
      },
      {
        path: "/salesDashboard",
        name: "SalesDashboard",
        components: { default: SalesDashboard },
        beforeEnter: isAuthenticated,
        meta: {
          navbarType: "light",
        },
      },
      {
        path: "/databaseDashboard",
        name: "DatabaseDashboard",
        components: { default: DatabaseDashboard },
        beforeEnter: isAuthenticated,
        meta: {
          navbarType: "light",
        },
      },
      {
        path: "/scheduledDashboard",
        name: "ScheduledDashboard",
        components: { default: ScheduledDashboard },
        beforeEnter: isAuthenticated,
        meta: {
          navbarType: "light",
        },
      },
      {
        path: "/systemDashboard",
        name: "SystemDashboard",
        components: { default: SystemDashboard },
        beforeEnter: isAuthenticated,
        meta: {
          navbarType: "light",
        },
      },
      {
        path: "/statusDashboard",
        name: "StatusDashboard",
        components: { default: StatusDashboard },
        beforeEnter: isAuthenticated,
        meta: {
          navbarType: "light",
        },
      },
      {
        path: "/analyticsDashboard",
        name: "AnalyticsDashboard",
        components: { default: AnalyticsDashboard },
        beforeEnter: isAuthenticated,
        meta: {
          navbarType: "light",
        },
      },
      {
        path: "/positionDetails",
        name: "PositionDetails",
        components: { default: PositionDetails },
        beforeEnter: isAuthenticated,
        meta: {
          navbarType: "light",
        },
      },
      {
        path: "/widgets",
        name: "Widgets",
        components: { default: Widgets },
      },
      {
        path: "/charts",
        name: "Charts",
        components: { default: Charts },
      },
      {
        path: "/calendar",
        name: "Calendar",
        components: { default: Calendar },
      },
      {
        path: "/pages/user",
        name: "Profile",
        components: { default: Profile },
      },
      {
        path: "/pages/timeline",
        name: "Timeline",
        components: { default: Timeline },
      },
      {
        path: "/strategyDashboard",
        name: "StrategyAnalysisDashboard",
        components: { default: StrategyAnalysisDashboard },
        beforeEnter: isAuthenticated,
        meta: {
          navbarType: "light",
        },
      },
      {
        path: "/StrategyDetails/:month",
        name: "StrategyMonthlyData",
        components: { default: StrategyMonthlyData },
        beforeEnter: isAuthenticated,
        meta: {
          navbarType: "light",
        },
      },
      {
        path: "/PausedStatus/details",
        name: "PausedStatus",
        components: { default: PausedStatus },
        beforeEnter: isAuthenticated,
        meta: {
          navbarType: "light",
        },
      },
    ],
  },
  {
    path: "/",
    redirect: "/",
    component: AuthLayout,
    children: [
      {
        path: "/pricing",
        name: "Pricing",
        components: { default: Pricing },
      },
      {
        path: "/login",
        name: "Login",
        components: { default: Login },
      },
      {
        path: "/homePage",
        name: "HomePage",
        components: { default: HomePage },
        meta: {
          hideFooter: true,
          hideSidebar: true,
        },
      },
      {
        path: "/register",
        name: "Register",
        components: { default: Register },
      },
      {
        path: "/lock",
        name: "Lock",
        components: { default: Lock },
      },
    ],
  },
  componentsMenu,
  tablesMenu,
  mapsMenu,
  formsMenu,
  systemMenu,
  reportMenu,
  buttonsMenu
];
function isAuthenticated(to, from, next) {
  const isAuthenticated = store.getters['authStore/isLoggedIn'];
  if (isAuthenticated == true) {
    next();
  } else {
    next("/homePage");
  }
}
const router = createRouter({
  history: createWebHashHistory(),
  linkActiveClass: "active",
  routes,
});

export default router;
